import { NgModule } from '@angular/core';
import { yepdeskEventsDesktopComponent } from './yepdesk-events-desktop/yepdesk-events-desktop.component';
import { yepdeskEventsMobileComponent } from './yepdesk-events-mobile/yepdesk-events-mobile.component';
import { CommonModule } from '@angular/common';
@NgModule({
    declarations: [
        yepdeskEventsDesktopComponent,
        yepdeskEventsMobileComponent
       
    ],
    imports: [
        CommonModule
        
    ],
    exports:[
        yepdeskEventsDesktopComponent,
        yepdeskEventsMobileComponent
    
    ]
  })
  export class  yepdeskEventsModule{ }
  